'use strict';//Indicating browser should run only in java script mode

angular.module('EMR.Home').service('AlertsCommonService', ['$http', 'CommonService', function ($http, CommonService) {
	//################# TO GET PATIENT CHART ALERTS LINKED PATIENT IDS BLOCK START #################
	//********	This is to get patient chart alerts linked patient ids.
	//********	CREATED BY			: Swaraj B
	//********	CREATED DATE		: 11 May, 2019
	//********	MODIFIED DEVELOPER	: DATE - NAME - WHAT IS MODIFIED
	this.GetPatientChartAlertsLinkedPatientIDsList = function (postData) {
		postData.practicemodel = EMRPracticeModel;
		return CommonService.PostData('POST', CommonService.EMRPracticeManagement_Alerts() + "GetPatientChartAlertsLinkedPatientIDsList", postData).then(
			function (result) {
				return result;
			});
	};
	//################# TO GET PATIENT CHART ALERTS LINKED PATIENT IDS BLOCK END #################
}]);